/**
 * desc : 图片展示样式-轮播
 */
<template>
<div class="comp-image-swpier-layer" :style="`background-color: ${backgroundColor}`">
  <section class="comp-image-swiper swiper-container" :style="`background-color: ${backgroundColor}`">
    <div class="swiper-wrapper">
      <div v-for="(image, index) in imgs" :key="index" data-actionid="1" data-itemtext="图片类组件" :data-itemotherinfo="getLink(image)" @click="clickHandle(image, index)" class="swiper-slide" v-show="image.show">
        <img width="100%" :src="`${picHost+image.imgLink}`" @load="loadHandler">
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </section>
</div>
</template>
<script>
import mixin from './image_mixin.js'
import { eventBus } from '@/utils'

export default {
  mixins: [mixin],
  watch: {
    compProps: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$nextTick(() => {
            // eslint-disable-next-line
            this.swiper = new Swiper(`#comp_id_${this.compId} .comp-image-swiper`, {
              autoplay: {
                delay: this.delay
              },
              pagination: {
                el: '.swiper-pagination'
              }
            })
          })
        }
      }
    }
  },
  computed: {
    backgroundColor() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.backgroundColor
      }
    }
  },
  methods: {
    loadHandler($event) {
      eventBus.$emit('imageOnload')
    }
  }
}
</script>
<style lang="scss" scoped>
.comp-image-swiper {
  margin: 0 1.3333rem;
  // border-radius: 0.4rem;
  img {
    border-radius: 0rem;
    cursor: pointer;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  :global(.swiper-pagination) {
    text-align: right;
  }
  :global(.swiper-pagination-bullet) {
    width: 0.2666rem;
    height: 0.2666rem;
    opacity: 0.5;
    background-color: #fff;
    margin: 0 0.1666rem;
    border-radius: 50%;

    &:last-child {
      margin-right: 0.6666rem;
    }
  }

  :global(.swiper-pagination-bullet-active) {
    opacity: 1;
  }
}
</style>
